<template>
    <div class="subcontract_box animate__animated animate__fadeIn">
        <div class="subcontract">
            <div class="search_box">
                <div class="text">参建单位</div>
                <div class="search_btn" @click="fnOpenEditSubcontract('add')"><span>新增分包单位</span></div>
                <!--                <div class="search_btn upload" @click="fnUploadSubcontractCq2" v-if="APP.fnCheckRegion('31')">
                    <span>上传重庆市建委平台</span>
                </div> -->
                <div class="search_btn upload" @click="fnUploadSubcontractQb"><span>上传千变平台</span></div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">参建单位类型</div>
                    <div class="title_item">参建单位统一社会信用代码</div>
                    <div class="title_item">参建单位名称</div>
                    <div class="title_item">企业负责人姓名</div>
                    <div class="title_item">企业负责人联系电话</div>
                    <div class="title_item">上传时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="subcontractList">
                            <div class="box_line" v-for="(item, index) in subcontractList" :key="index">
                                <div class="list_item">{{ CQ2.inviteList[item.corpType] }}</div>
                                <div class="list_item">{{ item.corpCode }}</div>
                                <div class="list_item">{{ item.corpName }}</div>
                                <div class="list_item">{{ item.responsiblePersonName }}</div>
                                <div class="list_item">{{ item.responsiblePersonPhone }}</div>
                                <div class="list_item">
                                    {{ ( item.upload_at ?  ('已上传至重庆市建委—'+item.upload_at+' ' ): '') + APP.fnUploadObjToText(item.extend) }}
                                </div>
                                <div class="list_item">
                                    <div>
                                        <button class="item_btn blue"
                                            @click="fnOpenEditSubcontract(item)"><span>编辑</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 添加分包单位弹窗 -->
            <div class="dialog_subcontract" v-if="subcontractWindow">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="subcontractTitle"
                    center :visible.sync="subcontractWindow">
                    <div class="subcontract_list">
                        <div class="subcontract_item">
                            <div class="reason_body" style="color: #FF0000; padding-left: 20px;">
                                提示：*必填，建议全填</div>

                            <div class="reason_body">
                                <div class="body_item">参建单位统一社会代码*</div>
                                <div class="body_item"><input type="text" class="input_box" v-model="form.corpCode"
                                        placeholder="请输入9位或18位统一社会信用代码" /></div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">参建单位名称*</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.corpName"
                                        placeholder="请输入参建单位名称" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">参建单位类型*</div>
                                <div class="body_item">
                                    <el-select v-model="form.corpType" :popper-append-to-body="false" filterable
                                        placeholder="请选择参建单位类型">
                                        <el-option v-for="(item, index) in CQ2.inviteList" :key="index" :label="item"
                                            :value="index"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">负责人姓名</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.responsiblePersonName"
                                        placeholder="请输入负责人姓名" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">责任人联系电话</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.responsiblePersonPhone"
                                        placeholder="请输入责任人联系电话" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">项目责任人证件号码</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.responsiblePersonIDNumber"
                                        placeholder="请输入责任人证件号码" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">进退场类型*</div>
                                <div class="body_item">
                                    <el-select v-model="form.entryExitType" :popper-append-to-body="false" filterable
                                        placeholder="请选择进退场类型">
                                        <el-option key="0" label="退场" value="0"></el-option>
                                        <el-option key="1" label="进场" value="1"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">进场时间</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.entryTime" type="date"
                                        placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">退场时间</div>
                                <div class="body_item">
                                    <el-date-picker value-format="yyyy-MM-dd" v-model="form.exitTime" type="date"
                                        placeholder="选择日期"></el-date-picker>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">工资账户所属银行</div>
                                <div class="body_item">
                                    <el-select v-model="form.bankCode" :popper-append-to-body="false" filterable
                                        placeholder="请选择工资账户所属银行">
                                        <el-option label="请选择" value=""></el-option>
                                        <el-option v-for="(item, index) in CQ2.bankList" :key="index" :label="item"
                                            :value="index"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">银行支行名称</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.bankName"
                                        placeholder="请输入银行支行名称" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">银行卡号</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.bankNumber"
                                        placeholder="请输入银行卡号" />
                                </div>
                            </div>
                            <div class="reason_body">
                                <div class="body_item">银行联号</div>
                                <div class="body_item">
                                    <input type="text" class="input_box" v-model="form.bankLinkNumber"
                                        placeholder="请输入银行联号" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="subcontractWindow = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnAddSubcontract"><span>保存</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>

            <!-- 上传失败信息弹窗-->
            <div class="dialog_perError" v-if="showErrorInfo">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" top="20vh" :modal="false"
                    title="分包单位上传失败" :visible.sync="showErrorInfo" center>
                    <div class="cont_list">
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item,index) in errorInfoList" :key="index">
                                        <div class="list_item">{{ item.msg }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        fnRequestPlatform
    } from '@/utils/upload';
    import APP from '@/utils/base';
    import request from '@/utils/request';
    import CQ2 from '@/configure/cq2';
    import {
        Loading
    } from 'element-ui';
    import {
        fnUpload
    } from '@/utils/upload';
    import * as imageConversion from 'image-conversion';
    export default {
        data() {
            return {
                APP: APP,
                CQ2: CQ2,
                showErrorInfo: false, //上传错误弹窗
                errorInfoList: [], // 错误列表
                subcontractTitle: '新增分包单位', // 弹窗名称
                detailId: '',
                form: {
                    corpCode: '', // 参建单位统一社会信用代码
                    corpName: '', // 参建单位名称
                    corpType: '', // 参建单位类型
                    responsiblePersonName: '', // 负责人姓名
                    responsiblePersonPhone: '', // 责任人联系电话
                    responsiblePersonIDNumber: '', // 责任人证件号码
                    entryExitType: '1', // 进退场类型
                    entryTime: '', // 进场日期
                    exitTime: '', // 退场日期
                    bankCode: '', // 银行代码
                    bankName: '', // 银行支行名称
                    bankNumber: '', // 银行卡号
                    bankLinkNumber: '', // 银行联号
                },
                formRequired: {
                    corpCode: '', // 参建单位统一社会信用代码
                    corpName: '', // 参建单位名称
                    corpType: '', // 参建单位类型
                    entryExitType: '', // 进退场类型
                },
                subcontractWindow: false, // 添加、编辑分包单位弹窗
                subcontractList: [], // 分包单位列表
                personnelList: [], // 项目下人员列表
            };
        },
        created() {
            this.fnGetSubcontract();
        },
        methods: {
            // 上传重庆市建委
            fnUploadSubcontractCq2() {
                fnRequestPlatform({
                        url: '/Cq2/uploadCorpInfo',
                        method: 'GET'
                    },
                    res => {
                        this.fnGetSubcontract();
                        if (res.code === 1) {
                            this.$message.success(res.data);
                            return;
                        }
                        if (typeof(res.data) !== 'string') {
                            this.errorInfoList = res.data;
                            this.showErrorInfo = true;
                        } else {
                            this.$message.error(res.data);
                        }
                    }
                );
            },
            fnUploadSubcontractQb() {
                fnRequestPlatform({
                        url: '/Qb/uploadCorpInfo',
                        method: 'GET'
                    },
                    res => {
                        this.fnGetSubcontract();
                        if (res.code === 1) {
                            this.$message.success(res.data);
                            return;
                        }
                        if (typeof(res.data) !== 'string') {
                            this.errorInfoList = res.data;
                            this.showErrorInfo = true;
                        } else {
                            this.$message.error(res.data);
                        }
                    }
                );
            },

            // 打开新增分包单位弹窗
            fnOpenEditSubcontract(item) {
                if (item != "add") {
                    this.subcontractTitle = '查看分包单位详情';
                    this.detailId = item.id;
                    this.form.corpCode = item.corpCode; // 参建单位统一社会信用代码
                    this.form.corpName = item.corpName; // 参建单位名称
                    this.form.corpType = item.corpType; // 参建单位类型
                    this.form.responsiblePersonName = item.responsiblePersonName; // 负责人姓名
                    this.form.responsiblePersonPhone = item.responsiblePersonPhone; // 责任人联系电话
                    this.form.responsiblePersonIDNumber = item.responsiblePersonIDNumber; // 责任人证件号码
                    this.form.entryExitType = item.entryExitType; // 进退场类型
                    this.form.entryTime = item.entryTime; // 进场日期
                    this.form.exitTime = item.exitTime; // 退场日期
                    this.form.bankCode = item.bankCode; // 银行代码
                    this.form.bankName = item.bankName; // 银行支行名称
                    this.form.bankNumber = item.bankNumber; // 银行卡号
                    this.form.bankLinkNumber = item.bankLinkNumber; // 银行联号
                    this.subcontractWindow = true;
                } else {
                    this.subcontractTitle = '新增分包单位';
                    this.detailId = '';
                    this.form.corpCode = ''; // 参建单位统一社会信用代码
                    this.form.corpName = ''; // 参建单位名称
                    this.form.corpType = ''; // 参建单位类型
                    this.form.responsiblePersonName = ''; // 负责人姓名
                    this.form.responsiblePersonPhone = ''; // 责任人联系电话
                    this.form.responsiblePersonIDNumber = ''; // 责任人证件号码
                    this.form.entryExitType = ''; // 进退场类型
                    this.form.entryTime = ''; // 进场日期
                    this.form.exitTime = ''; // 退场日期
                    this.form.bankCode = ''; // 银行代码
                    this.form.bankName = ''; // 银行支行名称
                    this.form.bankNumber = ''; // 银行卡号
                    this.form.bankLinkNumber = ''; // 银行联号
                    this.subcontractWindow = true;
                }
            },
            // 获取所有分包单位
            fnGetSubcontract(_cb) {
                request({
                        url: 'project/getAllRegionExtend',
                        method: 'GET',
                        params: {
                            region: 'cq2_corp'
                        }
                    })
                    .then(res => {
                        _cb && _cb(res);
                        this.subcontractList = res.data;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 添加分包单位
            fnAddSubcontract() {
                for (let key in this.formRequired) {
                    if (!this.form[key]) {
                        return this.$message.warning('参数不能为空');
                    }
                }
                if (this.form.corpCode.length != 9 && this.form.corpCode.length != 18) {
                    return this.$message.warning('请填写9位或者18位统一社会信用代码！');
                }

                this.form.region = 'cq2_corp';

                if (this.detailId != '') {
                    this.form.id = this.detailId
                }

                request({
                        url: 'project/addAllRegionExtend',
                        method: 'POST',
                        data: this.form
                    })
                    .then(res => {
                        this.$message.success(res.data);
                        this.subcontractWindow = false;
                        this.fnGetSubcontract();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .subcontract_box {
        width: 1920px;
        height: 858px;
        position: relative;
        overflow: hidden;

        .subcontract {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
    }

    .search_box {
        width: 1880px;
        height: 50px;
        margin-top: 24px;
        margin-left: 20px;
        text-align: center;
        font-size: 34px;

        .search_btn {
            width: 166px;
            height: 36px;
            background: url(../../../assets/img/btn_bg_mid.png) no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: 40px;
            top: 35px;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center, center);

            &.upload {
                width: 180px;
                left: 210px;
            }

            span {
                margin-top: -5px;
            }
        }
    }

    .cont_list {
        margin-top: 29px;
        margin-left: 28px;
        width: 1864px;
        height: 755px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1864px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(2) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 266px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 267px;
                    margin-right: 30px;
                }
            }
        }

        .list_boxes {
            width: 1864px;
            height: 707px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1804px;
                    height: 70px;
                    margin: 7px 0 0 30px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 190px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 306px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 286px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 266px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 267px;
                        }

                        span {
                            width: 100%;
                            cursor: pointer;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        div {
                            @include flex-box(center, center);

                            .item_btn {
                                width: 69px;
                                height: 32px;
                                line-height: 32px;
                                margin: 0 2px;
                                font-size: 14px;
                                color: #ffffff;
                                border: none;
                                cursor: pointer;
                                @include flex-box(center, center);

                                &.blue {
                                    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                &.red {
                                    background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
                                    background-size: 100% 100%;
                                }

                                span {
                                    margin-top: -2px;
                                }
                            }
                        }

                        img {
                            width: 68px;
                            height: 68px;
                        }
                    }
                }
            }
        }
    }

    .dialog_subcontract {
        >>>.el-dialog {
            width: 550px;
            height: 720px;
            margin-top: 20vh !important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4db4f4;
        }

        >>>.el-dialog__title {
            color: #4db4f4;
        }

        >>>.el-dialog__close {
            color: #4db4f4;
        }

        >>>.el-dialog__body {
            padding: 10px 20px;
        }

        .subcontract_list {
            width: 510px;
            height: 580px;
            position: relative;
            overflow: hidden;

            .subcontract_item {
                position: absolute;
                left: 0;
                right: -20px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;
            }
        }

        .reason_body {
            width: 510px;
            height: 40px;
            line-height: 40px;
            color: #4db4f4;
            margin: 0 auto;
            @include flex-box();

            .body_item {
                height: 40px;
                color: #ffffff;

                &:first-child {
                    width: 160px;
                    text-align: center;
                }

                &:nth-child(2) {
                    width: 280px;
                }

                .input_box {
                    background-color: rgba(49, 88, 128, 0.6);
                    width: 280px;
                    height: 30px;
                    line-height: 40px;
                    padding-left: 15px;
                    color: #4db4f4;
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }

                .select_box {
                    width: 280px;
                    height: 30px;
                    line-height: 30px;
                    border-radius: 2px;
                    background-color: rgba(49, 88, 128, 0.6);
                }

                img {
                    width: 100px;
                    height: 100px;
                }
            }

            >>>.el-input__inner {
                background-color: rgba(49, 88, 128, 0.6);
                width: 280px;
                height: 30px;
                border-radius: 2px;
                border: none;
                color: rgba(77, 180, 244, 0.7);

                /*background: transparent;*/
                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }

            >>>.el-select__caret {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown {
                background-color: rgba(9, 17, 32, 1);
                border: 1px solid rgba(77, 180, 244, 1);
            }

            >>>.popper__arrow {
                border-bottom-color: rgba(77, 180, 244, 1) !important;
            }

            >>>.el-select-dropdown__item {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.el-select-dropdown__item:hover {
                color: #409eff;
            }

            >>>.el-select-dropdown__item.hover {
                color: #409eff;
            }

            >>>.el-input__icon {
                color: rgba(77, 180, 244, 0.7);
            }

            >>>.avatar-uploader {
                line-height: 100px;
                margin-right: 10px;

                img {
                    width: 98px;
                    height: 98px;
                    border-radius: 2px;
                }
            }

            >>>.el-upload--picture-card {
                background-color: transparent;
            }

            >>>.el-upload {
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
        }

        .btn_line {
            @include flex-box(center, center);
        }
    }

    // 弹窗公共样式
    .dialog_perError {
        .btn_line {
            @include flex-box(center, center);
        }

        >>>.el-dialog {
            width: 910px;
            height: 600px;
            // margin-top: 20vh!important;
            background-color: rgba(9, 17, 32, 1);
            border: 1px solid rgba(58, 116, 221, 1);
        }

        >>>.el-form-item__label {
            color: #4DB4F4;
        }

        >>>.el-dialog__title {
            color: #4DB4F4;
        }

        >>>.el-dialog__close {
            color: #4DB4F4;
        }
    }

    .dialog_perError {
        >>>.el-dialog {
            width: 900px;
            height: 600px;
            // margin-top: 20vh!important;
        }

        .cont_list {
            width: 840px;
            height: 425px;
            color: #FFFFFF;
            font-size: 16px;
            border-radius: 10px;
            margin: 0;
            background-color: rgba(29, 68, 149, 0.1);

            .list_title {
                width: 840px;
                height: 48px;
                background: url(../../../assets/img/per_list_bg.png) no-repeat;
                background-size: 100% 100%;
                @include flex-box(flex-start, center);

                .title_item {
                    height: 48px;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        width: 154px;
                        margin: 0 4px 0 30px;
                    }

                    &:nth-child(2) {
                        width: 156px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 460px;
                        margin-right: 30px;
                    }
                }
            }

            .list_boxes {
                width: 780px;
                height: 377px;
                margin-left: 30px;
                position: relative;
                overflow: hidden;

                .list_box {
                    position: absolute;
                    left: 0;
                    right: -25px;
                    top: 0;
                    bottom: 0;
                    overflow-x: hidden;
                    overflow-y: auto;

                    .box_line {
                        width: 780px;
                        height: 70px;
                        margin: 5px 0 0 0px;
                        border-bottom: 1px dashed #1D4495;
                        @include flex-box(flex-start, center);

                        &:hover {
                            background-color: rgba(49, 88, 128, 0.4);
                        }

                        .list_item {
                            color: #F56C6C;
                            height: 70px;
                            text-align: center;
                            @include flex-box(center, center);

                            &:nth-child(1) {
                                width: 780px;
                            }

                            img {
                                width: 60px;
                                height: 60px;
                                border-radius: 50%;
                            }

                            span {
                                width: 100%;
                                cursor: pointer;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Subcontract/SubcontractQb/index.vue